<template>
  <div>
    <div
      v-for="e in filledExecutions"
      :key="e.monitoringID"
    >
      <v-icon v-if="e.fill" small>mdi-checkbox-blank-circle-outline</v-icon>
      <ExecutionPreview
        v-else
        :execution="e"
        :integrationID="integrationID"
        :processType="processType"
      />
    </div>
  </div>
</template>
<script>
import ExecutionPreview from './ExecutionPreview.vue'

export default {
  name: 'LastExecutions',

  components: { ExecutionPreview },

  props: {
    executions: {
      type: Array,
      required: true
    },
    processType: String,
    integrationID: String
  },

  computed: {
    sortedExecutions () {
      const comparator = (a, b) => (a.monitoringID < b.monitoringID) ? -1 : (a.monitoringID > b.monitoringID) ? 1 : 0
      return [...this.executions].sort(comparator)
    },
    filledExecutions () {
      const dif = 10 - this.sortedExecutions.length
      return [...this.sortedExecutions, ...Array(dif).fill({ fill: true })]
    }
  }

}
</script>
<style scoped>
div {
  display: inline !important;
}
</style>
